/*
 * A count on its way (design review "Loading and empty", P2 and P3): a tint bar two digits wide in the
 * count's own slot, so the line keeps its length when the number lands. It waits the thread's 180 ms
 * beat and breathes only where motion is welcome (`.lcr-opening`), and a screen reader hears nothing
 * of it: there is no number yet to read.
 */
export function PendingCount(props: { className: string }) {
  return (
    <span className={`${props.className} lcr-opening lcr-pending-count`} aria-hidden="true">
      <span className="lcr-skeleton" />
    </span>
  );
}
